import {
  booleanAttribute,
  computed,
  DestroyRef,
  Directive,
  inject,
  input,
  output,
} from '@angular/core';
import { nString, uString } from '@hidat/huijs-common';
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay';
import { PlaybackService } from '@splixer/player';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * Playback button base controller
 *
 * Styling Variables:
 *   --play-button-background
 *   --play-button-color
 *   --play-button-hover-color
 *   --play-button-hover-background
 */
@Directive()
export class PlayButtonController {
  public readonly eventSource = input.required<string>();
  public readonly backgroundImage = input<nString>(undefined);
  public readonly hint = input('Play Show');
  public readonly mixId = input<uString>(undefined);
  public readonly handlePlayback = input(false, {
    transform: booleanAttribute,
  });
  public readonly buttonClicked = output();

  protected playbackService = inject(PlaybackService);
  protected destroyRef = inject(DestroyRef);

  protected faPlay = faPlay;

  protected buttonClickedEvent = () => {
    const mixId = this.mixId();
    if (this.handlePlayback() && mixId) {
      this.playbackService
        .playMix(mixId, this.eventSource())
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((res) => {
          console.debug('Started playing ', mixId);
        });
    }
    this.buttonClicked.emit();
  };

  protected buttonStyles = computed(() => {
    const backgroundImage = this.backgroundImage();
    if (backgroundImage) {
      return {
        'background-image': "url('" + backgroundImage + "')",
        'background-position': 'center',
        'background-repeat': 'no-repeat',
        //'background-size': 'cover',
      };
    }
    return undefined;
  });
}
